import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function Keyboard() {
  return (
    <>
      <HeaderWithSearch />
      <main style={{
        minHeight: "100vh",
        width: "100%",
        background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
        padding: 0,
        margin: 0
      }}>
        <section style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
          padding: "60px 0 40px 0"
        }}>
          <h1 style={{ fontSize: "3rem", fontWeight: "bold", marginBottom: 12 }}>Keyboard Drawing</h1>
          <p style={{ fontSize: "1.3rem", color: "#333", marginBottom: 32 }}>A fun drawing of a keyboard using code.</p>
          <ImageWithFallback src="/keyboard.png" alt="Keyboard Drawing" style={{ width: 340, borderRadius: 24, boxShadow: "0 4px 32px rgba(0,0,0,0.10)", marginBottom: 24 }} />
          <div style={{ fontSize: "1.1rem", color: "#555", maxWidth: 600, textAlign: "center" }}>
            Try this creative keyboard drawing project!
          </div>
        </section>
      </main>
    </>
  );
}

export default Keyboard;
